import * as React from 'react'
import { ControlGroup, FormGroup, Radio, RadioGroup } from '@blueprintjs/core'
import { DatePicker } from '@blueprintjs/datetime'
import { stylizeTitle } from '../../products_v5/components/JoinedForm/Helpers'
import { UprightStyle } from '../../../types'
import { ShopifyOnChangeHandler } from '../../products_v5/components/JoinedForm/ShopifyCard/Inputs'
import './relistDialogScheduleTimeStyle.scss'

const scheduleTimePickerStyle: UprightStyle = {
  datePickerContainer: { maxWidth: 'fit-content', marginLeft: 15, marginTop: 60 },
  disabledDatePickerContainer: { pointerEvents: 'none', background: 'white', color: 'lightgrey' },
  select: { maxWidth: 115 }
}

interface ScheduleTimePickerRelistProps {
  value: string
  onChange: ShopifyOnChangeHandler
  error?: any
  disabled?: boolean
}

export const ScheduleTimePickerRelist: React.FC<ScheduleTimePickerRelistProps> = ({ value, onChange, error }) => {
  const [scheduleType, setScheduleType] = React.useState<string>('Use Current')
  const [scheduleTime, setScheduleTime] = React.useState<Date>()

  React.useEffect(() => {
    if (scheduleType === 'Use Current') {
      onChange({ name: 'scheduleTime', value: 'Use Current' })
    } else if (scheduleType === 'Immediately') {
      onChange({ name: 'scheduleTime', value: null })
    } else if (scheduleType === 'Scheduled') {
      onChange({ name: 'scheduleTime', value: scheduleTime })
    }
  }, [scheduleType, onChange, scheduleTime])

  return (
    <FormGroup label={stylizeTitle('Start Time', error)} intent={error ? 'danger' : 'none'}>
      <ControlGroup fill vertical={false}>
        <div style={scheduleTimePickerStyle.select}>
          <RadioGroup onChange={e => setScheduleType(e.currentTarget.value)} selectedValue={scheduleType}>
            <Radio label="Use Current" value="Use Current" />
            <Radio label="Immediately" value="Immediately" />
            <Radio label="Scheduled" value="Scheduled" />
          </RadioGroup>
        </div>
        <div style={scheduleTimePickerStyle.datePickerContainer}>
          <div style={scheduleType !== 'Scheduled' ? scheduleTimePickerStyle.disabledDatePickerContainer : {}}>
            <DatePicker
              value={value && value !== 'Use Current' ? new Date(value) : null}
              onChange={setScheduleTime}
              timePrecision="minute"
              timePickerProps={{ useAmPm: true }}
              minDate={new Date()}
              className={scheduleType !== 'Scheduled' ? 'relist-date-picker-disabled' : ''}
            />
          </div>
        </div>
      </ControlGroup>
    </FormGroup>
  )
}
